<template>
  <div>
    <div class="container-fluid m-0 p-0">
      <div class="row bg-light text-left border-top border-bottom py-2 ml-1">
        <div class="col-sm-12 h-100 my-auto p-0 m-0">
          <span class="mx-3 font-weight-bold lead">Admin Announcement Editor</span>
          <span class="mx-3">
                    <button class="btn btn-sm btn-outline-primary font-weight-bolder"
                            data-toggle="modal"
                            data-target="#add-admin-announcement"
                    >
                        <span class="fas fa-plus"></span>
                        Add Announcement
                    </button>
                </span>

          <span class="mx-3">
                    <button class="btn btn-sm btn-outline-success font-weight-bolder"
                            @click="previewAnnouncementModal"
                    >
                        <span class="fas fa-eye"></span>
                        Preview
                    </button>
                </span>

          <span class="float-right py-1 mx-2 pr-4">
                    <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                            @click="goBack"
                    >
                        <span class="fas fa-backward"></span>
                        Go Back
                    </button>
                </span>
        </div>
      </div>

      <div class="row text-small pt-3">
        <div class="col col-md-12" style="min-height: 450px !important;">

          <div class=" table-responsive text-small" style="height: 475px;">
            <table class="table table-hover table-bordered table-template-1 text-small sticky-header">
              <thead>
              <tr>
                <th>#</th>
                <th>TITLE</th>
                <th>MESSAGE</th>
                <th>DATE FROM</th>
                <th>DATE TO</th>
                <th>DAYS TO SHOW</th>
                <th class="col-actions">ACTION</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(announcement, index) in adminAnnouncementList" :key="announcement.id">
                <td class="text-center">{{ index + pagination.from }}</td>
                <td class="text-center" style="min-width: 200px">{{ announcement.title }}</td>
                <td class="text-center" style="min-width: 200px">{{ announcement.message }}</td>
                <td class="text-center">{{ announcement.date_from }}</td>
                <td class="text-center">{{ announcement.date_to }}</td>
                <td class="text-center">{{ announcement.daysAnnouncement }}</td>
                <td class="text-center col-actions" style="min-width: 100px">
<!--                  @click="viewAdminAnnouncement = announcement"-->
                  <button class="btn btn-sm btn-xs btn-outline-info font-weight-bolder mr-1 ml-auto"
                          data-toggle="modal"
                          data-target="#view-admin-announcement"
                          @click="setAdminAnnouncement(announcement)"
                  >
                    <span class="fas fa-eye"></span>
                    View
                  </button>
                  <button class="btn btn-sm btn-xs btn-outline-danger font-weight-bolder mr-1 ml-auto"
                          @click="confirmDeleteAdminAnnouncement(announcement.id)"
                  >
                    <span class="fas fa-trash-alt"></span>
                    Delete
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>

        <nav aria-label="..." class="ml-3 pt-2">
          <ul class="pagination text-smallest">
            <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
              <button class="page-link" @click="setPage(1)">First</button>
            </li>

            <li v-for="page in paginationPages" :key="page" class="page-item"
                :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
              <button class="page-link" @click="setPage(page)">{{ page }}</button>
            </li>

            <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
              <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
            </li>
          </ul>
        </nav>

      </div>

      <view-admin-announcement :view-admin-announcement="viewAdminAnnouncement"></view-admin-announcement>
      <add-admin-announcement></add-admin-announcement>

      <admin-announcement-modal></admin-announcement-modal>

    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {paginationMixin} from "@/mixins/paginationMixin";

import AddAdminAnnouncement from "@/components/sub_components/admin/admin-announcement/AddAdminAnnouncement";
import ViewAdminAnnouncement from "@/components/sub_components/admin/admin-announcement/ViewAdminAnnouncement";

import AdminAnnouncementModal from "@/components/sub_components/dashboards/AdminAnnouncementModal";
import $ from "jquery";

export default {
  name: "AdminAnnouncementIndex",

  mixins: [vueAppMixin, paginationMixin],

  // eslint-disable-next-line vue/no-unused-components
  components: {AddAdminAnnouncement, ViewAdminAnnouncement, AdminAnnouncementModal},

  data() {
    return {
      searchValue: '',
      viewAdminAnnouncement: {}
    }
  },

  methods: {
    ...mapActions([
      'getAdminAnnouncement',
      'deleteAdminAnnouncement'
    ]),

    async confirmDeleteAdminAnnouncement(AdminAnnouncementId) {
      if(await this.confirmDeleteAlert()) {
        let deleteAdminAnnouncement = await this.deleteAdminAnnouncement({ id: AdminAnnouncementId });
        if(deleteAdminAnnouncement) {
          this.successAlert('Admin Announcement Successfully Deleted', 'DELETE');
        } else {
          this.errorAlert('Admin Announcement Failed to Delete', 'DELETE');
        }
      }
    },

    async previewAnnouncement(){
      // await this.getAdminAnnouncement();
      let announcementData = [];
      this.adminAnnouncementList.forEach((value,index ) => {
        announcementData.push(value);
      });
      // this.systemAdminAnnouncementModal(announcementData[0].title, announcementData[0].message);
    },

    async previewAnnouncementModal(){
      let preview = '#view-admin-announcement-modal';
      $(preview).modal('show')
    },

    setAdminAnnouncement(announcement){
      this.viewAdminAnnouncement = Object.assign({}, announcement);

      // console.log(this.viewAdminAnnouncement, 'this.viewAdminAnnouncement')
      let newData = [];
      this.adminAnnouncementList.forEach((value,index ) => {
        newData.push(value);
      });

      console.log(newData, 'newData');

      console.log(this.adminAnnouncementList, 'adminAnnouncementList')
    },

  },

  computed: {
    ...mapGetters([
      'adminAnnouncementList',
    ])
  },

  created() {
    this.getAdminAnnouncement();
  }


}
</script>

<style scoped>

</style>